import React from 'react';
import { Spinner } from '../../flayr-components';
import ErrorMsg from '../../lib/ErrrorMsg/ErrorMsg';
import SuccessMsg from '../../lib/SuccessMsg/SuccessMsg';

interface IWizardFinishStepProps {
  loading?: boolean;
  success?: React.ReactNode;
  extension?: React.ReactNode;
  err?: React.ReactNode;
  info?: any;
  className?: string;
}

const WizardFinishStep: React.FC<React.PropsWithChildren<React.PropsWithChildren<IWizardFinishStepProps>>> = ({
  loading,
  err,
  success,
  className = '',
  extension,
}) => {
  return (
    <div className={`flex items-center content-center py-8 ${className}`}>
      <div className="mx-auto">
        {loading && <Spinner showing />}
        {!!err && (
          <ErrorMsg
            message={
              <>
                {err}
                {extension}
              </>
            }
          />
        )}
        {!!success && (
          <SuccessMsg
            message={
              <>
                {success}
                {extension}
              </>
            }
          />
        )}
      </div>
    </div>
  );
};
export default WizardFinishStep;
